import { render, staticRenderFns } from "./travelView.vue?vue&type=template&id=4d8c95f4"
import script from "./travelView.vue?vue&type=script&lang=js"
export * from "./travelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports